import { httpClient } from '@/services/http/http-client';
import type { Page } from '@/types/api.types';

import {
  type MembershipPackage,
  type MembershipPackageInput,
  membershipPackageSchema,
  type PtPackage,
  type PtPackageInput,
  ptPackageSchema,
} from '../schemas/package.schema';

/** The only place this feature talks to the network. */

/** A gym has a handful of packages, so one page of the maximum size holds them all. */
const ALL = { page: 1, pageSize: 100 };

// --- Membership plans ---------------------------------------------------------------------

export function listMembershipPackages(signal?: AbortSignal): Promise<Page<MembershipPackage>> {
  return httpClient.getPage('/membership-packages', {
    schema: membershipPackageSchema,
    query: ALL,
    signal,
  });
}

export function createMembershipPackage(input: MembershipPackageInput): Promise<MembershipPackage> {
  return httpClient.post('/membership-packages', input, { schema: membershipPackageSchema });
}

export function updateMembershipPackage(
  id: number,
  input: MembershipPackageInput,
): Promise<MembershipPackage> {
  return httpClient.patch(`/membership-packages/${String(id)}`, input, {
    schema: membershipPackageSchema,
  });
}

export function setMembershipPackageActive(
  id: number,
  isActive: boolean,
): Promise<MembershipPackage> {
  return httpClient.patch(
    `/membership-packages/${String(id)}/status`,
    { isActive },
    { schema: membershipPackageSchema },
  );
}

// --- Personal-training packages --------------------------------------------------------------

export function listPtPackages(signal?: AbortSignal): Promise<Page<PtPackage>> {
  return httpClient.getPage('/pt-packages', { schema: ptPackageSchema, query: ALL, signal });
}

export function createPtPackage(input: PtPackageInput): Promise<PtPackage> {
  return httpClient.post('/pt-packages', input, { schema: ptPackageSchema });
}

export function updatePtPackage(id: number, input: PtPackageInput): Promise<PtPackage> {
  return httpClient.patch(`/pt-packages/${String(id)}`, input, { schema: ptPackageSchema });
}

export function setPtPackageActive(id: number, isActive: boolean): Promise<PtPackage> {
  return httpClient.patch(
    `/pt-packages/${String(id)}/status`,
    { isActive },
    { schema: ptPackageSchema },
  );
}
